export const isAndroid = (): boolean =>
  navigator.userAgent.toLowerCase().indexOf('android') > -1;
